import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initializeState } from "./store/slice/gestionImageSlice";
import { GetInfoClient } from "./store/slice/InfoClientSlice";
import {
  GetMagasin,
  GetProduits,
  GetDataRoulleteByMagasin,
} from "./store/slice/DataApp";
import { BackLoadingSimple } from "./composant/loading/backLoading";
import { checkIsAuth, get_user } from "./store/slice/AuthSlice";
import IndexRoute from "./indexRoute";
import { AlertProvider } from "./service/AlertServices";

function App() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.dataApp);
  const { IsAuth } = useSelector((state) => state.Auth);
  const [check, setCheck] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(GetProduits());
      dispatch(GetMagasin());
      dispatch(initializeState());
      dispatch(GetInfoClient());
      dispatch(GetDataRoulleteByMagasin(1));
      await dispatch(checkIsAuth());
      await dispatch(get_user());
      setCheck(true);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <AlertProvider>
        {!loading && check ? <IndexRoute /> : <BackLoadingSimple open={true} />}
      </AlertProvider>
    </div>
  );
}

export default App;
